<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="user">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          {{ dataId ? '查看' : '新增' }}用户
          <!-- <el-button type="success" class="button-sty button-add" icon="el-icon-circle-plus-outline">新增</el-button> -->
        </div>
        <div class="fr">
          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置</el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <el-tabs v-model="activeName" class="tab-boxCard tabCard-sty1">
        <el-tab-pane label="基本信息" name="first">
          <div class="d-cont">
            <div class="d-item">
              <div class="title first"><b>基本信息</b></div>
              <table class="table-detail">
                <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      登录名
                    </th>
                    <td>
                      <el-form-item prop="loginAccount" :rules="[{ required: true, trigger: 'blur' }]">
                        <template v-if="dataId">
                          <el-input size="small" v-model="user.loginAccount" maxlength="255" autocomplete="off" lay-verify="required" required="" :readonly="true" />
                        </template>
                        <template v-else>
                          <el-input size="small" v-model="user.loginAccount" maxlength="255" autocomplete="off" lay-verify="required" required="" clearable />
                        </template>
                      </el-form-item>
                    </td>
                    <th>手机</th>
                    <td>
                      <el-form-item prop="mobile" :rules="[{ required: false, trigger: 'blur' }]">
                        <el-input size="small" v-model="user.mobile" type="text" maxlength="255" autocomplete="off" lay-verify="required|phone" clearable />
                      </el-form-item>
                    </td>
                    <th>密码</th>
                    <td>
                      <el-form-item prop="password" :rules="passRules">
                        <el-input size="small" type="password" v-model="user.password" show-password maxlength="255" autocomplete="off" auto-complete="new-password" clearable />
                      </el-form-item>
                    </td>
                    <th>确认密码</th>
                    <td>
                      <el-form-item prop="rePassword" :rules="pass2Rules">
                        <el-input
                          size="small"
                          type="password"
                          v-model="user.rePassword"
                          show-password
                          maxlength="255"
                          autocomplete="off"
                          auto-complete="new-password"
                          lay-verify="confirmPass"
                          clearable
                        />
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      姓名
                    </th>
                    <td>
                      <el-form-item prop="nickName" :rules="[{ required: true, trigger: 'blur' }]">
                        <el-input size="small" v-model="user.nickName" maxlength="200" lay-verify="required" required="" clearable />
                      </el-form-item>
                    </td>
                    <th>性别</th>
                    <td>
                      <el-radio-group v-model="user.gender">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                      </el-radio-group>
                    </td>
                    <th>出生日期</th>
                    <td><el-date-picker size="small" v-model="user.birth" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" clearable /></td>
                    <th>邮编</th>
                    <td><el-input size="small" v-model="user.zipCode" maxlength="255" clearable /></td>
                  </tr>
                  <tr>
                    <th>地址</th>
                    <td colspan="3"><el-input size="small" v-model="user.address" class="b" maxlength="255" clearable /></td>
                    <th>设置</th>
                    <td colspan="3"><el-checkbox label="是否启用" v-model="user.enabled"></el-checkbox></td>
                  </tr>
                  <tr>
                    <th>头像</th>
                    <td colspan="7"><baseUpload :limit="1" accept="image/png, image/jpeg" multi="false" :file.sync="user.headPhotoUrl" dataType="medium"></baseUpload></td>
                  </tr>
                  <tr>
                    <th>创建人</th>
                    <td>{{ user.createBy }}</td>
                    <th>创建时间</th>
                    <td>{{ user.createDate }}</td>
                    <th>更新人</th>
                    <td>{{ user.modifyBy }}</td>
                    <th>更新时间</th>
                    <td>{{ user.modifyDate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-item">
              <div class="title">
                <b>机构信息</b>
                <el-button class="button-sty" @click="showSaleOrgDialog = true" icon="el-icon-search">选择机构</el-button>
              </div>
              <div>
                <vxe-grid
                  ref="saleOrgGrid"
                  :data="user.userSaleOrgDTOs"
                  v-bind="vxeOption"
                  @resizable-change="$vxeTableUtil.onColumnWitchChange"
                  @custom="$vxeTableUtil.customHandle"
                ></vxe-grid>
              </div>
            </div>
            <div class="d-item">
              <div class="title">
                <b>所属组织</b>
                <el-button class="button-sty" @click="showCompanyDialog = true" icon="el-icon-search">选择组织</el-button>
              </div>
              <div>
                <vxe-grid
                  ref="companyInfoGrid"
                  :data="user.userCompanyInfoDTOs"
                  v-bind="companyInfoOption"
                  @resizable-change="$vxeTableUtil.onColumnWitchChange"
                  @custom="$vxeTableUtil.customHandle"
                ></vxe-grid>
              </div>
            </div>
            <div class="d-item">
              <div class="title">
                <b>角色信息</b>
                <el-button class="button-sty" @click="showRoleDialog = true" icon="el-icon-search">选择角色</el-button>
              </div>
              <div>
                <vxe-grid
                  ref="userRoleGrid"
                  :data="user.userRoleDTOs"
                  v-bind="userRoleOption"
                  @resizable-change="$vxeTableUtil.onColumnWitchChange"
                  @custom="$vxeTableUtil.customHandle"
                ></vxe-grid>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <roleDialog v-if="showRoleDialog" :visiable.sync="showRoleDialog" @confirm="confirmRole" :param="{ queryAll: true }" />
    <companyDialog v-if="showCompanyDialog" :visiable.sync="showCompanyDialog" @confirm="confirmInsertCompany" />
    <saleOrgDialog v-if="showSaleOrgDialog" :visiable.sync="showSaleOrgDialog" @confirm="confirmInsertSaleOrg" :param="{ queryAll: true }" />
    <positionDialog v-if="showPositionDialog" :visiable.sync="showPositionDialog" :rows="positionDialogDatas" @confirm="confirmInsertPosition" :param="{ queryAll: true }" />
  </div>
</template>

<script>
import roleDialog from '@/views/user/role/dialog.vue';
import companyDialog from '@/views/user/company_info/dialog.vue';
import saleOrgDialog from '@/views/user/sale_org/dialog.vue';

export default {
  name: 'UserEdit',
  components: {
    roleDialog,
    companyDialog,
    saleOrgDialog
  },
  props: ['_dataId'],
  data() {
    var validatePass = (rule, value, callback) => {
      const isPassRequired = !this.dataId;
      if (isPassRequired && (value == '' || value == undefined)) {
        callback(new Error('密码不能为空'));
      } else {
        callback();
      }
      this.$refs.editForm.validateField('rePassword');
    };
    var validatePass2 = (rule, value, callback) => {
      const isPassRequired = !this.dataId;
      const rePassword = value != undefined ? value : '';
      const password = this.user.password != undefined ? this.user.password : '';

      if (isPassRequired && rePassword == '') {
        callback(new Error('确认密码不能为空'));
      } else if (rePassword != password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      showExtendedProperties: false,
      dataId: '',
      hBtn: true,
      user: {
        userCompanyInfoDTOs: [],
        userSaleOrgDTOs: [],
        userRoleDTOs: [],
        enabled: true,
        userType: 0
      },
      vxeOption: {},
      companyInfoOption: {},
      userRoleOption: {},
      showRoleDialog: false,
      showCompanyDialog: false,
      showSaleOrgDialog: false,
      showPositionDialog: false,
      saleOrgPositionIndex: 0,
      passRules: [{ validator: validatePass, trigger: 'blur', required: false }],
      pass2Rules: [{ validator: validatePass2, trigger: 'blur', required: false }],
      activeName: 'first'
    };
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  mounted() {
    this.initSaleOrg();
    this.initCompanyInfo();
    this.initUserRole();
    this.getData();
  },
  methods: {
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: USER_PREFIX + `/user/get`,
          method: `post`,
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
          success: res => {
            let user = res.objx || {};
            user.userCompanyInfoDTOs = this.user.userCompanyInfoDTOs;
            user.userSaleOrgDTOs = this.user.userSaleOrgDTOs;
            user.userRoleDTOs = this.user.userRoleDTOs;
            this.user = user;
            this.user.password = '';

            this.showExtendedProperties = true;
          }
        });
      } else {
        this.isEdit = false;
        this.showExtendedProperties = true;
      }
    },
    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            var url = USER_PREFIX + (this.isEdit ? '/user/update' : '/user/save');
            this.$http({
              url: url,
              method: `post`,
              data: this.user,
              isLoading: true,
              success: res => {
                this.$message({
                  message: res.content,
                  type: 'success',
                  duration: 500,
                  onClose: t => {
                    if (this.isEdit) {
                      this.$baseReload();
                    } else {
                      this.$baseReload({
                        updateParam: {
                          _dataId: res.objx
                        }
                      });
                    }
                  }
                });
              }
            });
          });
        }
      });
    },
    initSaleOrg() {
      const tableOption = {
        vue: this,
        tableRef: 'saleOrgGrid',
        tableName: 'editUser-saleOrgGrid',
        columns: [
          { type: 'checkbox', fixed: 'left', width: 48, resizable: false },
          { title: '机构名称', field: 'saleOrgName', width: 200 },
          { title: '机构编码', field: 'sn', width: 200 },
          { title: '所属组织', field: 'companyName', width: 150 },
          {
            title: '是否默认',
            field: 'defaults',
            width: 120,
            slots: {
              default: ({ row, $table, $rowIndex, items }) => {
                var isDefault = row.defaults || false;
                return [
                  <el-checkbox
                    v-model={isDefault}
                    onchange={() => {
                      items.forEach((item, index) => {
                        if (index == $rowIndex) {
                          item.defaults = true;
                        } else {
                          item.defaults = false;
                        }
                      });
                    }}
                  />
                ];
              }
            }
          },
          {
            width: 47,
            fixed: 'right',
            title: '',
            sortable: false,
            slots: {
              default: ({ row, $rowIndex, $table }) => {
                return [
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.user.userSaleOrgDTOs.splice($rowIndex, 1);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="删除" placement="top" popper-class="tooltip-skin">
                      <i class="el-icon-delete" />
                    </el-tooltip>
                  </a>
                ];
              }
            }
          }
        ]
      };
      this.$vxeTableUtil.initVxeTable(tableOption).then(opts => {
        this.vxeOption = opts;
      });
      //初始化机构数据
      if (this.dataId) {
        this.$http({
          url: USER_PREFIX + '/user/getUserSaleOrg',
          method: `post`,
          data: { id: this.dataId },
          isLoading: true,
          modalStrictly: true,
          success: res => {
            // this.$refs.saleOrgGrid.loadData(res.objx || []);
            this.user.userSaleOrgDTOs = res.objx || [];
          }
        });
      }
    },
    initCompanyInfo() {
      var that = this;
      const tableRef = 'companyInfoGrid';
      const tableOption = {
        vue: this,
        tableRef: tableRef,
        tableName: 'editUser-companyInfoGrid',
        columns: [
          { type: 'checkbox', fixed: 'left', width: 48, resizable: false },
          { field: 'companyName', title: '所属组织', width: 150 },
          {
            width: 47,
            fixed: 'right',
            title: '',
            sortable: false,
            slots: {
              default: ({ row, $rowIndex, $table }) => {
                return [
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.user.userCompanyInfoDTOs.splice($rowIndex, 1);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="删除" placement="top" popper-class="tooltip-skin">
                      <i class="el-icon-delete" />
                    </el-tooltip>
                  </a>
                ];
              }
            }
          }
        ]
      };
      this.$vxeTableUtil.initVxeTable(tableOption).then(opts => {
        this.companyInfoOption = opts;
      });
      //初始化所属组织数据
      if (this.dataId) {
        this.$http({
          url: USER_PREFIX + '/user/getUserCompanyInfo',
          method: `post`,
          data: { id: this.dataId },
          isLoading: true,
          modalStrictly: true,
          success: res => {
            // this.$refs.companyInfoGrid.loadData(res.objx || []);
            this.user.userCompanyInfoDTOs = res.objx || [];
          }
        });
      }
    },
    initUserRole() {
      const tableOption = {
        vue: this,
        tableRef: 'userRoleGrid',
        tableName: 'editUser-userRoleGrid',
        columns: [
          { type: 'checkbox', fixed: 'left', width: 48, resizable: false },
          {
            title: '角色名称',
            field: 'name',
            width: 200,
            slots: {
              default: ({ row }) => {
                if (!row.isAdd) {
                  return row.roleName;
                } else {
                  return row.name;
                }
              }
            }
          },
          { title: '所属组织', field: 'companyName', width: 150 },
          {
            width: 47,
            fixed: 'right',
            title: '',
            sortable: false,
            slots: {
              default: ({ row, $rowIndex, $table }) => {
                return [
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.user.userRoleDTOs.splice($rowIndex, 1);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="删除" placement="top" popper-class="tooltip-skin">
                      <i class="el-icon-delete" />
                    </el-tooltip>
                  </a>
                ];
              }
            }
          }
        ]
      };
      this.$vxeTableUtil.initVxeTable(tableOption).then(opts => {
        this.userRoleOption = opts;
      });
      //初始化角色数据
      if (this.dataId) {
        this.$http({
          url: USER_PREFIX + '/user/getUserRole',
          method: `post`,
          data: { id: this.dataId },
          isLoading: true,
          modalStrictly: true,
          success: res => {
            // this.$refs.userRoleGrid.loadData(res.objx || []);
            this.user.userRoleDTOs = res.objx || [];
          }
        });
      }
    },
    confirmRole(rows) {
      if (rows.length > 0) {
        const $grid = this.$refs.userRoleGrid;
        const tableData = $grid.getTableData().fullData;
        const map = {};
        tableData.forEach(function(item) {
          map[item.roleId + '_' + item.companyCode] = 1;
        });
        var items = [];
        rows.forEach(row => {
          const item = {
            roleId: row.id,
            roleName: row.name,
            companyCode: row.companyCode,
            companyName: row.companyName
          };
          if (!map[item.roleId + '_' + item.companyCode]) {
            items.push(item);
          }
        });
        // $grid.insertAt(items, -1);
        this.user.userRoleDTOs = this.user.userRoleDTOs.concat(items);
      }
    },
    confirmInsertCompany(rows) {
      if (rows.length > 0) {
        const $grid = this.$refs.companyInfoGrid;
        const tableData = $grid.getTableData().fullData;
        const map = {};
        tableData.forEach(function(item) {
          map[item.companyCode] = 1;
        });
        var items = [];
        rows.forEach(row => {
          const item = { companyCode: row.companyCode, companyName: row.companyName };
          if (!map[item.companyCode]) {
            items.push(item);
          }
        });
        // $grid.insertAt(items, -1);
        this.user.userCompanyInfoDTOs = this.user.userCompanyInfoDTOs.concat(items);
      }
    },
    confirmInsertSaleOrg(rows) {
      if (rows.length > 0) {
        const $grid = this.$refs.saleOrgGrid;
        const tableData = $grid.getTableData().fullData;
        const map = {};
        tableData.forEach(function(item) {
          map[item.saleOrgId + '_' + item.companyCode] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            companyCode: row.companyCode,
            companyName: row.companyName,
            defaults: false,
            saleOrgName: row.name,
            positions: [],
            saleOrgId: row.id,
            sn: row.sn
          };

          if (!map[item.saleOrgId + '_' + item.companyCode]) {
            items.push(item);
          }
        });
        if (items.length > 0 && tableData.length == 0) {
          items[0].defaults = true;
        }
        // $grid.insertAt(items, -1);
        this.user.userSaleOrgDTOs = this.user.userSaleOrgDTOs.concat(items);
      }
    }
  }
};
</script>
